export const formatDate = (date, format = 'dd/mm/yyyy') => {
  const
    day = new Date(date).getDate(),
    month = new Date(date).getMonth() + 1,
    year = new Date(date).getFullYear();

  return `${day}/${month}/${year}`
}



// WEBPACK FOOTER //
// ./src/utils/time.js